import {ACCESS_TOKEN} from "../constants/auth";
import {API_BASE_URL} from "../constants/api";
import axios from "axios";

const ApplicationService = {};

/**
 * Сохранение заявки.
 *
 * Поддерживает две формы вызова:
 *   saveApplication(name, email, telNumber, categoryId)      — старая, у семи существующих страниц;
 *   saveApplication({name, email, telNumber, categoryId, applicantType, companyName,
 *                    position, employeesCount, comment, website}) — витрина корпоративных курсов.
 *
 * Перевод на объект понадобился из-за B2B-полей: позиционных аргументов стало бы десять,
 * и порядок в вызове перестал бы читаться. Старую форму оставляем, чтобы не трогать
 * страницы Foundation, EMBA, Robotics и остальные.
 */
ApplicationService.saveApplication = async function (nameOrPayload, email, telNumber, categoryId) {
    const payload = (nameOrPayload && typeof nameOrPayload === 'object')
        ? nameOrPayload
        : {name: nameOrPayload, email, telNumber, categoryId};

    let data = new FormData();
    // undefined и null не отправляем: на бэке все новые параметры опциональны,
    // а строка "undefined" в поле компании выглядела бы в админке как настоящий ввод
    Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            data.append(key, value);
        }
    });

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/application/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}
ApplicationService.getAllApplicationsPageable = async function (page, limit, applicationStatus, categoryId, fullName, archived) {
    if (applicationStatus === undefined) {
        applicationStatus = null;
    }
    if (categoryId === undefined) {
        categoryId = null;
    }
    if (fullName === undefined) {
        fullName = null;
    }
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/application/get`,
        params: {
            page: page - 1,
            limit: limit,
            status: applicationStatus,
            categoryId: categoryId,
            fullName: fullName,
            archived: !!archived, // п.4.1: активные / архив
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return { data, hasMore };
}

ApplicationService.getAllApplicationsByStatusPageable = async function (page, limit, status) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/application/get?page=${page - 1}&limit=${limit}&status=${status}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return { data, hasMore };
}

ApplicationService.rejectApplicationById = async function (id) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/application/${id}/reject`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.deleteApplicationsById = async function (ids) {
    let data = new FormData();
    data.append("IDs", ids);
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/application/delete/multiple`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}


ApplicationService.commentApplicationsById = async function (ids, comment) {
    let data = new FormData();
    data.append("IDs", ids);
    data.append("comment", comment ? comment : " ");
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/application/comment/multiple`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ApplicationService.notifyApplicationsById = async function (ids, subject, message) {
    let data = new FormData();
    data.append("IDs", ids);
    data.append("subject", subject);
    data.append("message", message);
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/application/newsletter/notify-form/multiple`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// ТЗ updated п.6.1: сменить программу (категорию) в заявке
ApplicationService.changeApplicationCategory = async function (applicationId, categoryId) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/application/${applicationId}/category`,
        params: {categoryId: categoryId},
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.4.1: архивировать/разархивировать заявку
ApplicationService.setApplicationArchived = async function (id, archived) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/application/${id}/archive`,
        params: { archived: !!archived },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.4.1: массово архивировать/разархивировать выбранные заявки
ApplicationService.setApplicationsArchived = async function (ids, archived) {
    let data = new FormData();
    data.append("IDs", ids);
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/application/archive/multiple`,
        params: { archived: !!archived },
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.4.2: авто-архив заявок с созданными договорами за 2025–2026
ApplicationService.autoArchiveApplications = async function (fromYear = 2025, toYear = 2026) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/application/archive/auto`,
        params: { fromYear, toYear },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default ApplicationService;